var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58.27137mm",
    height: "94.421272mm",
    viewBox: "0 0 58.27137 94.421272",
    id: "svg1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-3.2352455,-335.59499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 15.623804,429.61241 c -0.311424,-0.35197 0.52794,-3.01482 6.022486,-19.10609 3.511389,-10.28341 6.382897,-18.78641 6.381128,-18.89555 -0.0018,-0.10914 -5.429063,-0.19844 -12.060655,-0.19844 -10.5851742,0 -12.1079782,-0.0505 -12.4713252,-0.41388 -0.308894,-0.3089 -0.337658,-0.49011 -0.113392,-0.71438 0.16527,-0.16527 0.301074,-0.6041 0.301788,-0.97517 9.65e-4,-0.50207 5.481123,-7.34247 21.4195752,-26.73615 11.780052,-14.3338 21.572359,-26.13225 21.760681,-26.21878 0.188322,-0.0865 0.608679,-0.29488 0.934127,-0.46302 0.711589,-0.36763 1.216499,-0.39825 1.008153,-0.0611 -0.08313,0.1345 0.01801,0.28333 0.224749,0.33073 0.284235,0.0651 -1.189788,4.66689 -6.044923,18.87158 l -6.420819,18.78542 12.155135,0.0688 c 13.47542,0.0763 13.131211,0.0302 12.594091,1.68673 -0.158769,0.48967 -0.421482,1.14375 -0.583807,1.45351 -0.162324,0.30976 -9.879667,12.2382 -21.594093,26.50764 -16.156581,19.68047 -21.438919,25.94851 -21.878656,25.96128 -0.318833,0.009 -0.653282,0.1359 -0.743219,0.28142 -0.223867,0.36222 -0.46423,0.31784 -0.891024,-0.16451 z",
    id: "path1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/energy.f99c19145a739ff00f9adc8b1268bc30.svg";
export { ForwardRef as ReactComponent };